export default __webpack_public_path__ + "static/media/telegram.1dc6289d.png";